<template>
  <SpotlightGroupItems :items="estates">
    <template #item="props">
      <SpotlightGroupItem :item="props.item" @on-item-click="onItemClick(props.item)">
        <template #title>{{ props.item.fullName }}</template>
        <template #enum>
          <Status
            size="is-size-7"
            :color="props.item.statusEnum.color"
            :text="props.item.statusEnum.value"
            class="m-t--2 m-r-5 m-l--2"
          />
        </template>
        <template #subtitle>
          <span>{{ props.item.typeEnum.filterName }}</span>
          <span class="is-inline-block m-l-3 m-r-3">•</span>
          <span>{{ props.item.jurisdiction.name }}</span>
        </template>
        <template #actions>
          <SpotlightEstateImpersonateUserAction
            :estate="props.item"
            @on-impersonate-click="onImpersonateClick(props.item)"
          />
          <SpotlightEstateInboxAction :estate="props.item" @on-inbox-click="onInboxClick" />
          <SpotlightEstateRestoreAction :estate="props.item" />
        </template>
      </SpotlightGroupItem>
    </template>
  </SpotlightGroupItems>
</template>

<script>
import { SpotlightGroup } from '@/modules/spotlight/models/SpotlightGroup';
import { Estate } from '@/modules/estate/models/Estate';
import Status from '@/modules/core/app/components/Status.vue';
import SpotlightGroupItems from '@/modules/spotlight/components/presentational/SpotlightGroupItems.vue';
import { EstateDetailsShowConfig } from '@/modules/core/ui/models/EstateDetailsShowConfig';
import EstateDetailsService from '@/modules/core/ui/services/EstateDetailsService';
import SpotlightGroupItem from '@/modules/spotlight/components/presentational/SpotlightGroupItem.vue';
import { EstateDetailsMainTabValue } from '@/modules/ops/constants/EstateDetailsMainTabValue';
import SpotlightEstateInboxAction from '@/modules/spotlight/components/stateful/actions/SpotlightEstateInboxAction.vue';
import SpotlightEstateRestoreAction from '@/modules/spotlight/components/stateful/actions/SpotlightEstateRestoreAction.vue';
import SpotlightEstateImpersonateUserAction from '@/modules/spotlight/components/stateful/actions/SpotlightEstateImpersonateUserAction.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightEstateGroup',
  emits: ['on-item-click'],
  components: {
    SpotlightEstateImpersonateUserAction,
    SpotlightEstateRestoreAction,
    SpotlightEstateInboxAction,
    SpotlightGroupItem,
    SpotlightGroupItems,
    Status
  },
  props: {
    group: SpotlightGroup
  },
  computed: {
    estates() {
      return Estate.mapModels(this.group.items);
    }
  },
  methods: {
    onItemClick(item, tab) {
      this.$emit('on-item-click', item);
      EstateDetailsService.show(
        new EstateDetailsShowConfig({
          component: this,
          modelId: item.id,
          tab: tab ?? EstateDetailsMainTabValue.NOTES
        })
      );
    },
    onInboxClick(estateId) {
      this.onItemClick(estateId, EstateDetailsMainTabValue.INBOX);
    },
    onImpersonateClick(item) {
      this.$emit('on-item-click', item);
    }
  }
};
</script>
